import { TablePagination } from "@mui/material";
import { BaseListModal } from "../../../../../../common/components/base_list_modal";
import { ObraArquivo } from "../../../../domain/models/obra_arquivo";
import { GridColDef } from "@mui/x-data-grid-pro";
import { StyledDataGrid } from "../../Obras_concretagem/components/styled_data_grid";

import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { PaginationProperties } from "../../../../../../common/utils/pagination_property";

/**
 * ObraArquivoListaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  columns: GridColDef[];
  items: ObraArquivo[];
  pagination: PaginationProperties;
  onClose: () => void;
  onNewItem: () => void;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const ObraArquivoListaModal = ({
  open,
  saving,
  loading,
  columns,
  items,
  pagination,
  onClose,
  onNewItem,
  onPageChange,
  onRowsPerPageChange,
}: Props) => {
  return (
    <BaseListModal
      open={open}
      saving={saving}
      loading={loading}
      title="Anexar Documento"
      onClose={onClose}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full flex flex-row justify-end items-center">
          <div>
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              sx={{ px: 2 }}
              onClick={onNewItem}>
              Novo
            </PrimaryButton>
          </div>
        </div>

        <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
          <StyledDataGrid
            tableName="obras_informacoes_gerais_5"
            disableColumnMenu={false}
            getRowId={(row: ObraArquivo) => row.idObraArquivo}
            columns={columns}
            loading={loading}
            height='65vh'
            rows={items}
            rowCount={items.length}
            pageSizeOptions={[100]}
            paginationMode="server"
            paginationModel={{
              page: pagination.page,
              pageSize: pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={pagination.totalItems}
            page={pagination.page - 1}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[100]}
            onPageChange={(_, p) => onPageChange(p)}
            onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />

        </div>
      </div>
    </BaseListModal>
  );
}